import { DateTime } from 'luxon'
import { useAuth } from '@hooks/useAuth'
import { useEmployee } from '@hooks/useEmployee'
import { useUserId } from './useUserId'

interface EmployeeNameOptions {
  startDate: DateTime
}

export const useEmployeeName = ({ startDate }: EmployeeNameOptions) => {
  const userId = useUserId()
  const employeeQuery = useEmployee({ userId, startDate })
  const { user } = useAuth()

  const isSelf = user?.id === userId
  const name = employeeQuery.data?.fullName ?? ''

  return { isSelf, name }
}
